import MyTable from '../../../components/MyTable';
import React from 'react';
import { connect } from 'react-redux';
import {compose} from "redux";
import { withRouter } from "react-router-dom";
import {
    initializeDataTable,
    nextPage,
    previousPage,
    changePerPage,
    sort,
    setActiveCustomer
} from '../../../actions/customerActions';
import CustomersFilter from "./CustomersFilter";


const mapStateToProps = (state) => {
    let { page, perPage, totalRecords, isFetching, sortDirection, sortField } = state.customer;
    let data = state.customer.data ? state.customer.data : [];

    const fields = {
        "Vorname": "firstname",
        "Nachname": "lastname",
        "Email": "email",
        "K.Nr.": "number",
        "Status": "status_text",
        "Rabatt": "customers.discount",
        "Umsatz": "customers.turnover",
        "Erstellt am": "created_at"
    };

    const idField = "id";

    const click = true;

    return {
        page,
        perPage,
        totalRecords,
        data,
        loading: isFetching,
        sortDirection,
        sortField,
        fields,
        idField,
        filterComponent: () => <CustomersFilter/>,
        click,
        sortFields: ['firstname', 'lastname', 'email', 'created_at', 'number']
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        initializeDataTable,
        nextPage: () => { dispatch(nextPage())},
        previousPage: () => {dispatch(previousPage())},
        changePerPage: (value => { dispatch(changePerPage(value))}),
        sort: (field, value) => { dispatch(sort(field, value))},
        onClickRow: (rowData) => {
            dispatch(setActiveCustomer({activeCustomer: rowData}));
        },
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(MyTable)
